var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.editor.version
    ? _c(
        "div",
        {
          staticClass: "page",
          class: {
            "study-locked":
              _vm.$store.state.editor.version.processStatus == 2 ||
              _vm.$store.state.editor.version.processStatus == 3,
          },
        },
        [
          _c(
            "div",
            { staticClass: "page-menu g3" },
            [
              _c("SideMenu", {
                ref: "sideMenu",
                attrs: { menu: _vm.sideMenu },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isPageLoading
            ? _c("div", { staticClass: "loading" }, [
                _vm.isPageLoading
                  ? _c("div", { staticClass: "dot-pulse" })
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "page-content g9",
              class: { "editor-loading": _vm.isPageLoading },
            },
            [
              _c(
                "header",
                [
                  _vm.showAnonymousMenu
                    ? [
                        _c("h2", { staticClass: "breadcrumb" }, [
                          _vm._v(_vm._s(_vm.project.title)),
                        ]),
                      ]
                    : [
                        _c(
                          "h2",
                          { staticClass: "breadcrumb" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: _vm.project.url } },
                              [_vm._v(_vm._s(_vm.project.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              { attrs: { to: _vm.program.url } },
                              [_vm._v(_vm._s(_vm.program.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "forecast-title",
                                attrs: { title: _vm.forecast.title },
                              },
                              [_vm._v(_vm._s(_vm.forecast.title))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "versions outline",
                            on: {
                              click: function ($event) {
                                return _vm.onToggleVersions($event, true)
                              },
                            },
                          },
                          [_vm._v("Latest")]
                        ),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("section", [
                _c("div", { staticClass: "headlines" }, [
                  _c("h2", [
                    _c("span", [_vm._v(_vm._s(_vm.routeSection + 1) + ".")]),
                    _vm._v(
                      " " + _vm._s(_vm.getHeadlines(_vm.routeSection).headline)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(
                      _vm._s(_vm.getHeadlines(_vm.routeSection).subHeadline)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      class: _vm.isCollapsed ? "" : "active",
                      on: {
                        click: function ($event) {
                          return _vm.onToggleCollapse()
                        },
                      },
                    },
                    [_vm._m(0)]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  { ref: "studyForm", attrs: { autocomplete: "disabled" } },
                  [
                    _vm.editorType === "study"
                      ? [
                          _c("StudyEditor", {
                            attrs: {
                              formValue: _vm.$store.state.editor.version.data,
                            },
                            on: {
                              setSideMenu: _vm.setSideMenu,
                              setHeadlines: _vm.setHeadlines,
                            },
                          }),
                        ]
                      : _vm.editorType === "aggregation"
                      ? [
                          _c("AggregatorEditor", {
                            attrs: {
                              formValue: _vm.$store.state.editor.version.data,
                              "is-page-loaded": _vm.isPageLoaded,
                            },
                            on: {
                              setSideMenu: _vm.setSideMenu,
                              setHeadlines: _vm.setHeadlines,
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bottom-menu" }, [
                  this.routeSection > 0
                    ? _c(
                        "button",
                        {
                          staticClass: "left outline",
                          on: {
                            click: function ($event) {
                              return _vm.goToPage(_vm.routeSection - 1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(this.routeSection) +
                              " " +
                              _vm._s(
                                this.getHeadlines(this.routeSection - 1)
                                  .headline
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.routeSection < _vm.sideMenu.length - 1
                    ? _c(
                        "button",
                        {
                          staticClass: "right outline",
                          on: {
                            click: function ($event) {
                              return _vm.goToPage(_vm.routeSection + 1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(this.routeSection + 2) +
                              " " +
                              _vm._s(
                                this.getHeadlines(this.routeSection + 1)
                                  .headline
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.openSideMenu
                ? _c(
                    "div",
                    {
                      staticClass: "versions modal show",
                      on: {
                        click: function ($event) {
                          return _vm.onToggleVersions($event, false)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "close" }),
                      _vm._v(" "),
                      _c("menu", [
                        _c("h2", [_vm._v("Versions")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.forecast.forecastVersions,
                            function (item, index) {
                              return _c(
                                "li",
                                {
                                  class:
                                    item.forecastVersionId ===
                                      _vm.$route.params.versionId ||
                                    (index == 0 &&
                                      _vm.$route.params.versionId == null)
                                      ? "active"
                                      : "",
                                },
                                [
                                  _c("div", {
                                    staticClass: "state",
                                    class: "status" + item.processStatus,
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to:
                                          "/" +
                                          _vm.editorType +
                                          "/" +
                                          _vm.$route.params.id +
                                          "/0/0/" +
                                          item.forecastVersionId,
                                      },
                                    },
                                    [
                                      item.title
                                        ? [
                                            _c("h5", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ]
                                        : index == 0
                                        ? [_c("h5", [_vm._v("Latest version")])]
                                        : [
                                            _c("h5", [
                                              _vm._v("Previous version"),
                                            ]),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$moment
                                          .utc(item.updateDate)
                                          .format("DD MMM YYYY HH:mm:ss")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "version-description" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "description" },
                                        [_vm._v(_vm._s(item.description))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "version-options" },
                                    [
                                      _c("div", { staticClass: "rename" }, [
                                        _c(
                                          "span",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openRenameModal(item)
                                              },
                                            },
                                          },
                                          [_vm._v("Rename")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.allowMakeTemplate(item)
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "make-template" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openTemplateModal(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("To template")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.allowDelete()
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "delete" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteVersion(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Delete")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "Modal",
                        {
                          ref: "modalRename",
                          attrs: { title: "Rename version" },
                        },
                        [
                          _c("form", { on: { submit: _vm.onRenameSubmit } }, [
                            _c(
                              "div",
                              { staticClass: "input", attrs: { type: "text" } },
                              [
                                _c("label", [
                                  _c("span", [_vm._v("Name")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.renameVersion.title,
                                        expression: "renameVersion.title",
                                      },
                                    ],
                                    ref: "renameVersionInput",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Version name",
                                    },
                                    domProps: {
                                      value: _vm.renameVersion.title,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.renameVersion,
                                          "title",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "right edit",
                                class: { loading: _vm.renameVersion.isLoading },
                              },
                              [_vm._v("Rename")]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Modal",
                        {
                          ref: "modalCreateTemplate",
                          attrs: { title: "Create template" },
                        },
                        [
                          _c(
                            "form",
                            { on: { submit: _vm.onCreateTemplateSubmit } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "input",
                                  attrs: { type: "text" },
                                },
                                [
                                  _c("label", [
                                    _c("span", [_vm._v("Name")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.createTemplate.title,
                                          expression: "createTemplate.title",
                                        },
                                      ],
                                      ref: "createTemplateInput",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Template name",
                                      },
                                      domProps: {
                                        value: _vm.createTemplate.title,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.createTemplate,
                                            "title",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "right edit",
                                  class: {
                                    loading: _vm.createTemplate.isLoading,
                                  },
                                },
                                [_vm._v("Create")]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.editor.validator.hasError ||
              _vm.$store.state.editor.validator.hasWarning
                ? _c(
                    "Modal",
                    { ref: "modalValidator", attrs: { title: "Input error" } },
                    [
                      _vm.$store.state.editor.validator.hasError
                        ? _c(
                            "div",
                            { staticClass: "validation-error" },
                            [
                              _c("h3", [_vm._v("Errors")]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.$store.state.editor.validator.errors,
                                function (item) {
                                  return _c("div", [
                                    _c("h4", [_vm._v(_vm._s(item.text))]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      _vm._l(item.errors, function (error) {
                                        return _c(
                                          "li",
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(error.text) +
                                                "\n                            "
                                            ),
                                            error.helper
                                              ? _c("HelperBox", {
                                                  attrs: { text: error.helper },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.state.editor.validator.hasWarning
                        ? _c(
                            "div",
                            { staticClass: "warning-error" },
                            [
                              _c("h3", [_vm._v("Warnings")]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.$store.state.editor.validator.warnings,
                                function (item) {
                                  return _c("div", [
                                    _c("h4", [_vm._v(_vm._s(item.text))]),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      _vm._l(item.warnings, function (warning) {
                                        return _c(
                                          "li",
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(warning.text) +
                                                "\n                            "
                                            ),
                                            warning.helper
                                              ? _c("HelperBox", {
                                                  attrs: {
                                                    text: warning.helper,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    ),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", [_vm._v("Collapse all fields")]),
      _vm._v(" "),
      _c("div", { staticClass: "check" }, [_c("div")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }